import React from "react";

function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76.759"
      height="47.346"
      viewBox="0 0 76.759 47.346"
      className="logo"
    >
      <g
        id="Group_2"
        data-name="Group 2"
        transform="translate(38.597 -16.937) rotate(45)"
      >
        <path
          id="Path_1"
          data-name="Path 1"
          d="M5.186,10.373h0A5.2,5.2,0,0,1,0,5.186H0A5.2,5.2,0,0,1,5.186,0h0a5.2,5.2,0,0,1,5.187,5.186h0A5.2,5.2,0,0,1,5.186,10.373Z"
          transform="translate(10.511 16.664)"
          fill="#ad7e73"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M30.017,15.009A15.053,15.053,0,0,0,15.008,0h0A15.053,15.053,0,0,0,0,15.009H0V36.941S30.014,33.6,30.017,15.011v0Z"
          transform="translate(23.952 0)"
          fill="#d4b2a6"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M0,15.256v0H0A10.473,10.473,0,0,0,10.442,25.7h0A10.473,10.473,0,0,0,20.884,15.259h0V0S0,2.325,0,15.256ZM10.442,18a2.744,2.744,0,1,1,2.744-2.744A2.752,2.752,0,0,1,10.442,18Z"
          transform="translate(0 28.883)"
          fill="#c6998b"
        />
      </g>
    </svg>
  );
}

export default Logo;
